module.exports = __webpack_public_path__ + "img/lg_ring_y_o_1_null@3x.82b45566.png";